
import { list } from '@fitogest/reactive-form-builder/utils';
import {
    Form,
    FormField,
    FormSection,
    FormType,
    DropdownData,
    InputType,
    ReactiveFormValue,
} from '@fitogest/reactive-form-builder/interfaces';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { ClienteModel } from 'src/app/models/cliente.model';
import { CrmModel } from 'src/app/models/crm/crm.model';

export class CRMFormDefinition {    
  public formType!: FormType;

  public model: ReactiveFormValue<CrmModel> = {} as ReactiveFormValue<CrmModel>;

  public tag = '';
    
  public formFieldsSection!: FormSection<object>;

  public formFieldsTitular!: FormSection<object>;

  public formFieldsResponsable!: FormSection<object>;
    
  public formFields!: Form<CrmModel>;

  public fieldNames: FormField<any>[] = [];

  public fieldLabels: string[] = [];

  public tareaComercial: DropdownData<string> = list(['...', null], 'Llamada', 'Email' , 'Reunión' , 'Demo' , 'Presupuesto');

  public estadoPresupuestos: DropdownData<string> = list(['...', null], 'Enviado', 'Aplazado' , 'Perdidos' , 'Confirmado' );

  public clientes: DropdownData<ClienteModel> | DropdownData<ClienteModel>[] = list();
  
  constructor(
    type: FormType, 
    _model: Record<string,string>,
    table: (string[] | string[][])[] | null
  ) {
    this.formType = +type;
    
    const action = this.formType === FormType.CREATION ? 'Crear' : 'Actualizar';

    this.formFields = {
      name: 'crm',
      header: action + ' Tarea comercial',
      type: this.formType,
      sections: this.getFormSections(),
      table: { title: '', showIndex: false, data: table?.[0], style: table?.[1]},
      uploadButton: {
        isEnabled: true,
        label: 'Adjuntar Documento'
      },
      signed: false
    };
  }



  public getFormFields(): FormField<any>[] {
    const formFields: FormField<any>[] = [
        {
            name: 'id_cliente',
            label: 'Cliente',
            input: {
                type: InputType.DROPDOWN_SEARCH, 
                isEditable: true,
                data: this.clientes,
                dropdownConfiguration: {
                    valuePrimaryKey: 'id',
                }
            },
            width: 4,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: true,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 1
        },
        {
            name: 'fecha',
            label: 'Fecha Acción Comercial',
            input: {type: InputType.CALENDAR, isEditable: true},
            width: 4,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: true,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 2
        },
        {
            name: 'tarea_comercial',
            label: 'Tarea comercial',
            input: {
                type: InputType.DROPDOWN,
                isEditable: true,
                data: this.tareaComercial,
            },
            width: 4,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: true,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 3
        },
        {
            name: 'interlocutor',
            label: 'Interlocutor',
            input: {type: InputType.TEXT, isEditable: true},
            width: 4,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 4
        },
        {
            name: 'estado_presupuesto',
            label: 'Estado presupuesto',
            input: {
                type: InputType.DROPDOWN, 
                isEditable: true, 
                data: this.estadoPresupuestos
            },
            width: 4,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 5
        },
        {
            name: 'realizado',
            label: 'Realizado',
            input: {type: InputType.SWITCH, isEditable: true},
            width: 4,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 6
        },
        {
            name: 'fecha_proxima_accion_comercial',
            label: 'Fecha Próxima Acción Comercial',
            input: {type: InputType.CALENDAR, isEditable: true},
            width: 4,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 7
        },
        {
            name: 'observaciones',
            label: 'Observaciones',
            input: {type: InputType.TEXTAREA, isEditable: true},
            width: 4,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 8
        },
        {
            name: 'productos',
            label: 'Productos',
            input: {type: InputType.TEXT, isEditable: true},
            width: 4,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 9
        },
        {
            name: 'venta_cruzada',
            label: 'Venta Cruzada',
            input: {type: InputType.TEXT, isEditable: true},
            width: 4,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 10
        }
    ];

    this.fieldNames = this.fieldNames.concat(formFields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(formFields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return formFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

    public getHiddenFields(): FormField<any>[] {
      const hiddenFields: FormField<any>[] = [
        {
          name: 'id',
          label: '',
          input: {
            type: InputType.HIDDEN,
            defaultValue: this.model.id,
            isEditable: false
          },
          width: 2,
          conditions: {
            isRememberedOnDuplicate: true,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: true,
          },
          order: 1
        },
        {
          name: 'id_usuario',
          label: '',
          input: {
            isEditable: false,
            defaultValue: StorageManager.getClient()?.id_usuario_asignado ?? this.model.id_usuario ?? StorageManager.getUser().id,
            type: InputType.HIDDEN,
          },
          updateValue: () =>  StorageManager.getClient()?.id_usuario_asignado ?? this.model.id_usuario ?? StorageManager.getUser().id,
          width: 3,
          conditions: {
            isRememberedOnDuplicate: true,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: true
          },
          order: 2
        },
      ];
  
      this.fieldNames = this.fieldNames.concat(hiddenFields.filter((it) => it.conditions.isVisible));
      this.fieldLabels = this.fieldLabels.concat(hiddenFields.filter((it) => it.conditions.isVisible).map(it => it.label));
      return hiddenFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }
    
  private getFormSections(): FormSection<any>[] {
    const sections: FormSection<any>[] = [
      {
        name: '',
        width: 12,
        isVisible: true,
        fields: this.getFormFields(),
        order: 1
      },
      {
        name: '',
        width: 12,
        isVisible: true,
        fields: this.getHiddenFields(),
        order: 2
      },
    ];

    return sections.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }
}